import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=7b6966f8&scoped=true&"
import script from "./NewsContent.vue?vue&type=script&lang=js&"
export * from "./NewsContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsContent.vue?vue&type=style&index=0&id=7b6966f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6966f8",
  null
  
)

export default component.exports